module.exports = "/images/baaf8fe952dfadaa6cd3f409d1cf3235.jpg";